/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountDetailSchema } from "./calculateDiscountDetailSchema.ts";
import { calculateDiscountItemSchema } from "./calculateDiscountItemSchema.ts";

export const calculateDiscountSchema = z.object({
	items: z.array(calculateDiscountItemSchema).optional(),
	combos: z.array(calculateDiscountDetailSchema).optional(),
	table: z.uuid().nullish(),
	order_type_id: z.uuid().nullish().describe("Внутренний ID выбранного типа заказа (Здесь/С собой)"),
	locator: z.string().max(8).nullish(),
	comment: z.string().max(50).nullish(),
	tab_name: z.string().max(50).nullish(),
	promo_code: z.string().optional(),
	total_cart_price: z.string(),
});
